import { useDownloadStatistics } from 'domains/ReportBuilder/hooks/useDownloadStatistics/useDownloadStatistics';
import {
  useReportSettings,
  useReportsList,
} from 'domains/ReportBuilder/model/selectors';
import { useUserTheme } from 'domains/user/model/selectors';
import { useTranslation } from 'react-i18next';
import { TUseHeader } from '../types';

export const useHeader: TUseHeader = (formik, columns) => {
  const { t } = useTranslation();
  const { isThemeExtended, isThemeFull } = useUserTheme();
  const { handleDownload } = useDownloadStatistics({ formik, columns });
  const { isLoading: isReportSettingsLoading } = useReportSettings();
  const { isLoading: isReportsTypeLoading } = useReportsList();
  const isFiltersLoading = isReportSettingsLoading || isReportsTypeLoading;

  return {
    t,
    isThemeExtended,
    isThemeFull,
    handleDownload,
    isFiltersLoading,
  };
};
